import React from 'react';

interface ChatSkeletonLoaderProps {
  isEmbedded?: boolean;
}

export const ChatSkeletonLoader: React.FC<ChatSkeletonLoaderProps> = ({ isEmbedded = false }) => {
  return (
    <div className="flex flex-col h-full bg-white dark:bg-ios-dark-gray6">
      {/* Skeleton Header */}
      <div className={`${
        isEmbedded
          ? 'sticky top-0 z-40'
          : 'fixed top-0 left-0 right-0 z-40'
      } flex items-center justify-between px-4 py-2 h-[3.5rem] bg-white/80 dark:bg-ios-dark-gray6/80 backdrop-blur-ios border-b border-ios-gray5 dark:border-ios-dark-gray5`}>
        <div className="h-5 w-16 bg-ios-gray4 dark:bg-ios-dark-gray4 rounded animate-pulse"></div>
        <div className="h-6 w-24 bg-ios-gray4 dark:bg-ios-dark-gray4 rounded animate-pulse"></div>
        <div className="h-8 w-8 bg-ios-gray4 dark:bg-ios-dark-gray4 rounded-full animate-pulse"></div>
      </div>

      {/* Skeleton Message List */}
      <div className={`flex-1 overflow-hidden px-4 ${
        isEmbedded ? 'pt-4' : 'pt-[4.5rem]'
      } pb-[5.5rem] animate-pulse space-y-4`}>
        {/* Mimic a few messages */}
        <div className="flex justify-start">
          <div className="w-8 h-8 rounded-full bg-ios-gray5 dark:bg-ios-dark-gray5 mr-2 flex-shrink-0"></div>
          <div className="w-3/5 h-10 bg-ios-gray5 dark:bg-ios-dark-gray5 rounded-2xl rounded-bl-none"></div>
        </div>
        <div className="flex justify-end">
          <div className="w-1/2 h-12 bg-ios-blue/30 dark:bg-ios-dark-blue/30 rounded-2xl rounded-br-none"></div>
          <div className="w-8 h-8 rounded-full bg-ios-gray4 dark:bg-ios-dark-gray4 ml-2 flex-shrink-0"></div>
        </div>
        <div className="flex justify-start">
          <div className="w-8 h-8 rounded-full bg-ios-gray5 dark:bg-ios-dark-gray5 mr-2 flex-shrink-0"></div>
          <div className="w-2/5 h-8 bg-ios-gray5 dark:bg-ios-dark-gray5 rounded-2xl rounded-bl-none"></div>
        </div>
         <div className="flex justify-end">
          <div className="w-3/4 h-16 bg-ios-blue/30 dark:bg-ios-dark-blue/30 rounded-2xl rounded-br-none"></div>
          <div className="w-8 h-8 rounded-full bg-ios-gray4 dark:bg-ios-dark-gray4 ml-2 flex-shrink-0"></div>
        </div>
         <div className="flex justify-start">
          <div className="w-8 h-8 rounded-full bg-ios-gray5 dark:bg-ios-dark-gray5 mr-2 flex-shrink-0"></div>
          <div className="w-1/3 h-10 bg-ios-gray5 dark:bg-ios-dark-gray5 rounded-2xl rounded-bl-none"></div>
        </div>
      </div>

      {/* Skeleton Input Area (Optional) */}
      {/* You can add a placeholder for the input area if needed */}
      {/* <div className="fixed bottom-16 left-0 right-0 z-50 h-[4.5rem] bg-white/80 dark:bg-ios-dark-gray6/80 border-t border-ios-gray5 dark:border-ios-dark-gray5"> ... </div> */}
    </div>
  );
};